
import { v4 as uuid } from 'uuid'

export class ExpenseEntry {
  uuid: string
  id: number  
  user_id: number  
  expense_type_id: number
  description: string
  mileage: number
  amount: number  
  expense_date: string  
  oil_calls: number
  stores_visited: string
  is_current_pay_period: boolean
  is_pending_save: boolean
  is_pending_delete: boolean

  constructor() { 
  }

  public async setViewModelFields()
  {
    if (!this.id) {
      this.id = 0
    }
    if (!this.uuid) {
      this.uuid = uuid();
    }
    if (this.is_pending_save === undefined) {
      this.is_pending_save = false
    }
    if (this.is_pending_delete === undefined) {
      this.is_pending_delete = false
    }
  }

  static buildOne(obj: any): ExpenseEntry {
    let target: ExpenseEntry = Object.assign(new ExpenseEntry(), obj)  
    target.setViewModelFields()
    return target
  }

  static buildMany(objs: any[]): ExpenseEntry[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ExpenseEntry.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

